<template>
  <v-btn text class="asc-close-button" @click="handleClick">
    <asc-close-icon :size="size"></asc-close-icon>
  </v-btn>
</template>

<script>
import AscCloseIcon from './AscCloseIcon'

export default {
  name: 'AscCloseButton',

  components: {
    AscCloseIcon,
  },

  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    size: {
      type: Number,
      default: 20,
    },
    id: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleClick() {
      if (this.onClose) {
        this.onClose()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-close-button {
  padding: 0 0 2px 0 !important;
  margin: 0;
  min-width: 20px;
  height: 24px !important;

  // eslint-disable-next-line vue-scoped-css/no-unused-selector
  .v-icon {
    right: 1px;
    top: 1px;
  }
}
</style>
